import styled from 'styled-components'
import { device } from '../../../styles/GlobalVariables'

export const VideoBreadCrumb = styled.div`
  display: flex;
  padding-right: 6vw;
  padding-left: 5.73vw;
  flex-direction: row;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 10px;
  margin-top: 30px;
  overflow-x: auto;
  max-width: 100%;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  -webkit-overflow-scrolling: touch; /* iOS smooth scroll */

  /* Safari and iOS */

  &::-webkit-scrollbar {
    display: none;
  }

  ${device.medium} {
    margin-bottom: 10px;
    margin-top: 20px;
  }
`
export const CrumbItem = styled.div`
  text-align: right;
  font-size: 18px;
  font-style: normal;
  line-height: normal;
  font-weight: 500;
  cursor: pointer;
  flex-shrink: 0;

  a {
    color: #969696;
    text-decoration: none;
  }
`
export const CurrentCrumb = styled(CrumbItem)`
  color: #fff;
  font-weight: 700;
  cursor: default;
`
